/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Value_During_TitleInputs */



/**
* | output |
* | --- |
* | "Support during the conversation" |
*
* @param {Onboarding_Value_During_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_value_during_title = /** @type {((inputs?: Onboarding_Value_During_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Value_During_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Ondersteuning tijdens het gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Du soutien pendant la conversation")
	return /** @type {LocalizedString} */ ("Support during the conversation")
});